import React from 'react';
export default (
  <svg width="16px" height="16px" viewBox="0 0 16 16">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-385.000000, -138.000000)">
        <g>
          <g transform="translate(384.000000, 137.000000)">
            <g>
              <rect id="Bound" x="0" y="0" width="18" height="18"></rect>
              <path
                d="M9.9752043,9.47349233 L9.9752043,1.95455571 C9.9752043,1.42736915 9.53869462,1 9.00023263,1 C8.46177065,1 8.02526097,1.42736915 8.02526097,1.95455571 L8.02526097,9.47349233 L6.93231773,8.40248083 C6.55108665,8.02949634 5.93320719,8.02971002 5.55224534,8.40295811 C5.17128348,8.77620619 5.17150174,9.38114722 5.55273282,9.75413171 L8.31092767,12.4526607 C8.49337911,12.6323169 8.74146576,12.7333333 9.00023263,12.7333333 C9.25899951,12.7333333 9.50708615,12.6323169 9.6895376,12.4526607 L12.4477324,9.75317715 C12.6941716,9.51172798 12.7903241,9.15989911 12.6999703,8.83022107 C12.6096165,8.50054303 12.3464832,8.24310176 12.0096903,8.1548729 C11.6728974,8.06664404 11.3136117,8.16103165 11.0671726,8.40248083 L9.9752043,9.47349233 Z M2.96571413,13.0541461 L2.96571413,14.8678443 L2.96571413,14.8678443 L15.1409525,14.8678443 L15.1409525,13.0008128 C15.1409525,12.487451 15.5571145,12.0712891 16.0704763,12.0712891 C16.583838,12.0712891 17,12.487451 17,13.0008128 L17,14.6545108 L17,14.6545108 C17,15.9112654 15.9766509,16.9300663 14.7142857,16.9300663 L3.28571429,16.9300663 C2.02334914,16.9300663 1,15.9112654 1,14.6545108 L1,13.0541461 C1,12.5113292 1.4400401,12.0712891 1.98285707,12.0712891 C2.52567404,12.0712891 2.96571413,12.5113292 2.96571413,13.0541461 Z"
                id="Icon"
                fill="#A2A8B0"
                fillRule="nonzero"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
